import React from 'react';
import { Form } from '@fulcrumapp/fulcrum-core';
import { FormSchema } from '@fulcrumapp/query-sql';
import { useForm, useRecord } from '../../../hooks';
import RecordEditor from '../../../record-editor';
import type { Instruction } from '../../../hooks/use-form-fields';

interface Props {
  recordId: string
  formId: string
  linkedFieldKey: string
  onClose?: () => void
}

function LinkedTaskEditor(props: Props) {
  const { recordId, formId, linkedFieldKey } = props;
  const { data: formData } = useForm(formId);
  const { data: recordData } = useRecord(recordId);

  const handleClose = () => {
    const { onClose } = props;

    if (onClose) {
      onClose();
    }

    return false;
  };

  if (formData && recordData) {
    const { restForm, queryColumns } = formData;
    const systemAppSchema = new FormSchema(
      new Form(restForm),
      queryColumns.form,
      queryColumns.repeatables,
      { fullSchema: true },
    );
    const instructions: Instruction[] = [{
      key: linkedFieldKey,
      changes: [{ attributeName: 'disabled', value: 'true' }],
    }];

    return (
      <RecordEditor
        row={recordData}
        formData={{ restForm, queryColumns, systemAppSchema }}
        handleCloseModal={handleClose}
        openRecordInEditor={() => {}}
        specialInstructions={instructions}
        title="task"
      />
    );
  }

  return <></>;
}

export default LinkedTaskEditor;
